let user = {
  id: null,
  name: null,
  email: null,
  type: null,
  currency: null,
  email_verified_at: null,
  token: null,
  business: [],
  branches:[],
  hotels:[]
}
let forgotpasswordStep1 ={
  email: null,
  phone: null,
  message: null,
}
export default {
  namespaced: true,
  state: {
    user,
    forgotpasswordStep1
  },
  mutations: {
    setUser(state , user){
      state.user = user;
    },
    setForgotpasswordStep1(state, payload) {
      state.forgotpasswordStep1 = {
        email: payload.email,
        phone: payload.phone,
        message: payload.message,
      };
    },
    resetUser(state){
      state.user = user;
    }
  },
  actions: {}
}
